import { render } from "./SidebarCategoryMobile.vue?vue&type=template&id=74a12200"
import script from "./SidebarCategoryMobile.vue?vue&type=script&lang=js"
export * from "./SidebarCategoryMobile.vue?vue&type=script&lang=js"
script.render = render

export default script